import type { ReactNode } from "react";
import { Text } from "@/components/Text";

const TONE_CLASS = {
  info: "bg-info-subtle text-info-on-subtle",
  warning: "bg-warning-subtle text-warning-on-subtle",
  error: "bg-error-subtle text-error-on-subtle",
} as const;

/** `action`: a BannerAction chip, which inherits the notice's text color. */
export function InlineNotice({
  tone = "info",
  action,
  children,
}: Readonly<{ tone?: keyof typeof TONE_CLASS; action?: ReactNode; children: ReactNode }>) {
  return (
    <div
      role={tone === "info" ? "note" : "alert"}
      className={`flex flex-wrap items-center gap-x-3 gap-y-2 rounded-lg px-4 py-3 ${TONE_CLASS[tone]}`}
    >
      <Text as="span" variant="body-sm" className="min-w-0 flex-1 text-inherit">
        {children}
      </Text>
      {action}
    </div>
  );
}
